import { render, staticRenderFns } from "./FooterTop.vue?vue&type=template&id=59af9b2a&scoped=true&"
import script from "./FooterTop.vue?vue&type=script&lang=js&"
export * from "./FooterTop.vue?vue&type=script&lang=js&"
import style0 from "./FooterTop.vue?vue&type=style&index=0&id=59af9b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59af9b2a",
  null
  
)

export default component.exports